module.exports = __webpack_public_path__ + "58c9fb9b89bf26a974c22f26a3c64eb7.svg";